import Swal from 'sweetalert2'

function base () {
  let $pageLoader = document.querySelector('#page-loader')
  if ($pageLoader) {
    $pageLoader.style.display = 'none'
  }


  let links = document.querySelectorAll('#header-nav a')
  if (links) {
    links.forEach(link => {
      if (link.getAttribute('href') === window.location.href) {
        link.parentNode.classList.add('active')
      }
    })
  }

  let dashboardLinks = document.querySelectorAll('.dashboardMenu a')
  if (dashboardLinks) {
    dashboardLinks.forEach(link => {
      if (link.getAttribute('href') === window.location.href) {
        link.classList.add('active')
      }
    })
  }

  let bookingLinks = document.querySelectorAll('.bookingList a')
  if (bookingLinks) {
    bookingLinks.forEach(link => {
      if (link.getAttribute('href') === window.location.href) {
        link.classList.add('active')
      }
    })
  }

  let $alerts = document.querySelectorAll('.alert')
  if ($alerts) {
    $alerts.forEach(alert => {
      alert.classList.add('in')
    })
  }


  // admin page

  let $notifications = document.querySelectorAll('[data-notification]')
  if ($notifications) {
    $notifications.forEach($notification => {
      $notification.addEventListener('click', (e) => {
        e.preventDefault()
        console.log('clicked')
        Swal({
          text: $notification.getAttribute('data-notification-content')
        })
      })
    })
  }


  let $themes = document.querySelectorAll('[data-sa-value]')
  if ($themes) {
    let localValue = window.localStorage.getItem('sa-value')
    if (localValue) {
      document.body.setAttribute('data-sa-theme', localValue)
    } else {
      document.body.setAttribute('data-sa-theme', 1)
    }
    $themes.forEach($theme => {
      let value = $theme.getAttribute('data-sa-value')
      if (value === localValue) {
        $theme.classList.add('active')
      }
      $theme.addEventListener('click', (e) => {
        e.preventDefault()
        window.localStorage.setItem('sa-value', value)
      })
    })
  }
}

export default base



// WEBPACK FOOTER //
// ./resources/assets/js/module/app.base.js